import React from "react";
import ModalContainer from "../containers/ModalContainer";
import ChartForm from "./ChartForm";
import chap_nm2dp from "./chap_nm2dp.json";

const ResultForm = ({
  result_table,
  achieve,
  name,
  st_grade,
  domainNames,
  start_dt,
  t_type,
  popupState,
  onClick,
  ooResultPaperClick,
  isPublic,
}) => {
  /*
   * 전달받은 result_table을 잘 가공해 jsx에 나타내기 위한 메소드
   */
  const handleResult = (result_table) => {
    const render_table = {};
    render_table["grade_range"] = [];
    const mid_domain_nms = [
      "수와 연산",
      "문자와 식",
      "함수",
      "기하",
      "확률과 통계",
    ];
    const ele_domain_nms = [
      "수와 연산",
      "도형",
      "측정",
      "규칙성",
      "자료와 가능성",
    ];
    const grade_range = result_table.grade_range;
    for (let i = 0; i < grade_range.length; i++) {
      let visit = {};
      let grade = grade_range[i];
      render_table["grade_range"] = grade_range;
      render_table[grade] = {};

      for (let month = 0; month < 12; month++) {
        render_table[grade][month] = [];
        if (!month) {
          render_table[grade][month].push(
            <th key={grade} rowSpan="12">
              {(parseInt(grade) % 7) + parseInt(parseInt(grade) / 7)}학년
            </th>
          );
        }
        let domain_nms = st_grade >= 7 ? mid_domain_nms : ele_domain_nms;
        for (let j = 0; j < domain_nms.length; j++) {
          let domain_nm = domain_nms[j];
          let chapter_nm = result_table[domain_nm][grade]["month_rep"][month];
          if (domain_nm + chapter_nm in visit) continue;
          visit[domain_nm + chapter_nm] = true;

          let is_weak_token = "";
          if (result_table[domain_nm][grade][chapter_nm].weakness === 1)
            is_weak_token = "td-improve";
          else if (result_table[domain_nm][grade][chapter_nm].weakness === 0)
            is_weak_token = "td-fine";
          else if (result_table[domain_nm][grade][chapter_nm].chap_cd === 0)
            is_weak_token = "td-blank";
          if (result_table[domain_nm][grade][chapter_nm].is_std === true) {
            is_weak_token += " td-line-bottom";
          }
          render_table[grade][month].push(
            <td
              key={domain_nm + chapter_nm}
              className={is_weak_token}
              rowSpan={result_table[domain_nm][grade][chapter_nm].ratio}
            >
              <div className="t-line">
                <div className="t-line-wrap">
                  <div className="dp-table">
                    <div className="dp-cell">
                      <p className="t-unit">{chap_nm2dp[chapter_nm]}</p>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          );
        }
      }
    }
    return render_table;
  };
  const render_table = handleResult(result_table);
  const grade_range = render_table.grade_range;
  const device_message = [
    <>
      아래의 결과표는 <span className="t-user">{name}</span> 학생이 잘할 수 있는
      단원과 보충해야 하는 단원을 영역별로 예측하여 나타낸 것입니다. 초등학교
      1~2학년 때는 선행 위주의 학습보다는 현재 배우고 있는 영역들의 기본 개념을
      꾸준히 익히며 연산 훈련을 통해 수학의 기본기를 다지고, 공부 습관을
      형성하는 것이 중요합니다. 아이스크림 홈런의 똑똑한 AI 추천학습으로 수학의
      기본기를 확실히 다지고 꾸준한 공부 습관을 만들어 보아요!
    </>,
    <>
      아래의 결과표는 <span className="t-user">{name}</span> 학생이 잘하는
      단원과 보충해야 하는 단원을 영역별로 예측하여 나타낸 것입니다. 초등학교
      3~4학년은 분수, 소수 등 새로운 개념을 배우기 시작하여 학습 난이도가
      높아지고, 과목도 많아져 심리적 부담이 커지는 한 시기입니다. 그렇기 때문에
      필요한 학습에 집중할 수 있도록 효율적인 학습이 필요합니다. 아이스크림
      홈런의 똑똑한 AI 추천학습으로 부족한 영역은 꼼꼼하게 보충하고 잘하고 있는
      영역은 심화 문제 풀이로 강화시켜 수학 실력을 탄탄하게 다져 보아요!
    </>,
    <>
      아래의 결과표는 <span className="t-user">{name}</span> 학생이 잘하는
      단원과 보충해야 하는 단원을 영역별로 예측하여 나타낸 것입니다. 초등학교
      5~6학년은 초등 수학 개념을 완성하고 문제 해결 능력을 키우는 시기입니다.
      특히 중등 과정과 연결되는 개념이 많기 때문에 이때 놓치는 부분이 생기면
      중등 수학을 따라가기 어려워집니다. 현재까지 배운 모든 개념을 빈틈없이
      익히고 응용 문제 풀이까지 꼼꼼하게 학습해야 합니다. 아이스크림 홈런의
      똑똑한 AI 추천학습으로 아직 부족한 영역의 개념 보충과 문제 해결 능력을
      길러 초등 수학 과정을 마스터해 보아요!
    </>,
    <>
      아래의 결과표는 <span className="t-user">{name}</span> 학생의 앞으로
      학습할 수학 과정들의 이해도를 예측한 그래프입니다. 잘할 수 있는 단원과 좀
      더 보충해야 할 단원을 영역별로 분석하여 예측 결과표로 나타냈습니다. 중학교
      1학년 수학은 초등학교와 비교해 질적으로 많은 변화가 있는 시기입니다.
      개념의 일반화가 이루어지고, 새로운 문자의 등장과 기호의 생략등으로 자칫
      수학에 대한 거부감이 발생할 수도 있습니다. 무리한 선행학습보다는 기본
      개념을 탄탄하게 다지면서 수학 공부에 흥미를 붙여야 합니다. 천리길도 한걸음
      부터! 아이스크림 홈런의 똑똑한 AI 추천 학습으로 쉽고 재미있게 진짜 실력을
      쌓아보세요!
    </>,
    <>
      아래의 결과표는 <span className="t-user">{name}</span> 학생의 앞으로
      학습할 수학 과정들의 이해도를 예측한 그래프입니다. 잘할 수 있는 단원과 좀
      더 보충해야 할 단원을 영역별로 분석하여 예측 결과표로 나타냈습니다. 중학교
      2학년에서 3학년까지의 과정은 전체 수학 과정의 허리와도 같은 중요한
      시기입니다. 수학교과는 연계성이 짙은 과목으로 중등 수학에 학습 누수가
      발생하면 고등 수학을 따라가기 어려워집니다. 따라서 무리한 선행학습보다는
      누수된 기본 개념을 탄탄히 하고 나아가 심화 문제풀이 위주로 공부한다면
      중학교 수학 의 강자가 될 수 있습니다. 아이스크림 홈런의 똑똑한 AI 추천
      학습으로 부족한 단원에 대한 개념 완성과 심화, 응용 문제 풀이를 꾸준히하여
      중등 수학을 마스터해 보아요!
    </>,
  ];
  const web_message = [
    <>
      아래의 결과표는 <span className="t-user">{name}</span> 학생이 잘할 수 있는
      단원과 보충해야 하는 단원을 영역별로 예측하여 나타낸 것입니다. 초등학교
      1~2학년 때는 선행 위주의 학습보다는 현재 배우고 있는 영역들의 기본 개념을
      꾸준히 익히며 기본기를 다지고, 공부 습관을 형성하는 것이 중요합니다.
      아이스크림 홈런의 똑똑한 AI 추천학습으로 수학의 기본기를 확실히 다지고
      꾸준한 공부 습관을 만들어 보아요!
    </>,
    <>
      아래의 결과표는 <span className="t-user">{name}</span> 학생이 잘하는
      단원과 보충해야 하는 단원을 영역별로 예측하여 나타낸 것입니다. 초등학교
      3~4학년은 분수, 소수 등 새로운 개념을 배우기 시작하여 학습 난이도가
      높아지고, 과목도 많아져 심리적 부담이 크기도 한 시기입니다. 그렇기 때문에
      필요한 학습에 집중할 수 있도록 더욱 효율적인 학습이 필요합니다. 아이스크림
      홈런의 똑똑한 AI 추천학습으로 부족한 영역은 꼼꼼하게 보충하고 잘하는
      영역은 심화 문제 풀이로 강화시켜 수학 실력을 탄탄하게 다져 보아요!
    </>,
    <>
      아래의 결과표는 <span className="t-user">{name}</span> 학생이 잘하는
      단원과 보충해야 하는 단원을 영역별로 예측하여 나타낸 것입니다. 초등학교
      5~6학년은 초등 수학 개념을 완성하고 문제 해결 능력을 키우는 시기입니다.
      특히 중등 과정과 연결되는 개념이 많기 때문에 이때 놓치는 부분이 생기면
      중등 수학을 따라가기 어려워집니다. 현재까지 배운 모든 개념을 빈틈없이
      익히고 응용 문제 풀이까지 꼼꼼하게 학습해야 합니다. 아이스크림 홈런의
      똑똑한 AI 추천학습으로 아직 부족한 영역의 개념 보충과 문제 해결 능력을
      길러 초등 수학 과정을 마스터해 보아요!
    </>,
    <>
      아래의 결과표는 <span className="t-user">{name}</span> 학생의 앞으로
      학습할 수학 과정들의 이해도를 예측한 결과표입니다. 잘할 수 있는 단원과 좀
      더 보충해야 할 단원을 영역별로 분석하여 예측 결과표로 나타냈습니다. 중학교
      1학년 수학은 초등학교와 비교해 질적으로 많은 변화가 있는 시기입니다.
      개념의 일반화가 이루어지고, 새로운 문자의 등장과 기호의 생략등으로 자칫
      수학에 대한 거부감이 발생할 수도 있습니다. 무리한 선행학습보다는 기본
      개념을 탄탄하게 다지면서 수학 공부에 흥미를 붙여야 합니다. 천리길도 한걸음
      부터! 아이스크림 홈런의 똑똑한 AI 추천 학습으로 쉽고 재미있게 진짜 실력을
      쌓아보세요
    </>,
    <>
      아래의 결과표는 <span className="t-user">{name}</span> 학생의 앞으로
      학습할 수학 과정들의 이해도를 예측한 결과표입니다. 잘할 수 있는 단원과 좀
      더 보충해야 할 단원을 영역별로 분석하여 예측 결과표로 나타냈습니다. 중학교
      2학년에서 3학년까지의 과정은 전체 수학 과정의 허리와도 같은 중요한
      시기입니다. 수학교과는 연계성이 짙은 과목으로 중등 수학에 학습 누수가
      발생하면 고등 수학을 따라가기 어려워집니다. 따라서 무리한 선행학습보다는
      누수된 기본 개념을 탄탄히 하고 나아가 심화 문제풀이 위주로 공부한다면
      중학교 수학의 강자가 될 수 있습니다. 아이스크림 홈런의 똑똑한 AI 추천
      학습으로 부족한 단원에 대한 개념 완성과 심화, 응용 문제 풀이를 꾸준히하여
      중등 수학을 마스터해 보아요!
    </>,
  ];
  return (
    <>
      <div className="wrapper">
        <div className="math-AI-scanning">
          <div className="AI-result">
            <header className="result-header">
              <h1 className="top-title">AI스캐닝 수학 진단평가</h1>
              {t_type === "reg-mem" && (
                <div className="top-close">
                  <button
                    className="btn-close"
                    onClick={() => {
                      window.handleConfirm();
                    }}
                  >
                    <i className="icon i-top-close">닫기</i>
                  </button>
                </div>
              )}
            </header>
            <main className="result-main">
              <div className="result-main-wrap">
                <div className="rm-top">
                  <h2 className="rm-top-title">
                    <span className="ai-user">{name}</span>
                    <span className="ai-txt">
                      학생의 AI스캐닝 수학 진단평가 결과
                    </span>
                  </h2>
                  <div className="rm-top-date">
                    <span>평가일자:</span>
                    <span>
                      {String(start_dt).substr(0, 4)}년{" "}
                      {String(start_dt).substr(5, 2)}월{" "}
                      {String(start_dt).substr(8, 2)}일
                    </span>
                  </div>
                </div>
                <div className="rm-content">
                  <section className="section section1">
                    <h2 className="ai-title">
                      영역별 적정 수준 이해도 분석 현황
                    </h2>
                    <div className="ai-con">
                      <div className="ai-con-wrap">
                        <div className="uibox uibox-l">
                          <ChartForm
                            achieve={achieve}
                            grade={st_grade}
                            domainNames={domainNames}
                            is_result={true}
                          ></ChartForm>
                        </div>
                        <div className="uibox uibox-r">
                          <ul className="graph-list-grp">
                            <li className="graph-list">
                              <span className="gl-title">수와 연산</span>
                              <div className="gl-con">
                                <div className="gl-con-wrap">
                                  <div className="line-graph-box">
                                    <span
                                      className="graph-current-bar"
                                      style={{
                                        width:
                                          String(
                                            (achieve &&
                                              (
                                                achieve["수와 연산"] * 100
                                              ).toFixed(1)) + 0
                                          ) + "%",
                                      }}
                                    >
                                      <span className="current-txt">
                                        {achieve &&
                                          (achieve["수와 연산"] * 100).toFixed(
                                            1
                                          )}
                                        %
                                      </span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </li>
                            <li className="graph-list">
                              <span className="gl-title">
                                {domainNames[1][0]}
                              </span>
                              <div className="gl-con">
                                <div className="gl-con-wrap">
                                  <div className="line-graph-box">
                                    <span
                                      className="graph-current-bar"
                                      style={{
                                        width:
                                          String(
                                            (achieve &&
                                              (
                                                achieve[domainNames[1][1]] * 100
                                              ).toFixed(1)) + 0
                                          ) + "%",
                                      }}
                                    >
                                      <span className="current-txt">
                                        {achieve &&
                                          (
                                            achieve[domainNames[1][1]] * 100
                                          ).toFixed(1)}
                                        %
                                      </span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </li>
                            <li className="graph-list">
                              <span className="gl-title">
                                {domainNames[2][0]}
                              </span>
                              <div className="gl-con">
                                <div className="gl-con-wrap">
                                  <div className="line-graph-box">
                                    <span
                                      className="graph-current-bar"
                                      style={{
                                        width:
                                          String(
                                            (achieve &&
                                              (
                                                achieve[domainNames[2][1]] * 100
                                              ).toFixed(1)) + 0
                                          ) + "%",
                                      }}
                                    >
                                      <span className="current-txt">
                                        {achieve &&
                                          (
                                            achieve[domainNames[2][1]] * 100
                                          ).toFixed(1)}
                                        %
                                      </span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </li>
                            <li className="graph-list">
                              <span className="gl-title">
                                {domainNames[3][0]}
                              </span>
                              <div className="gl-con">
                                <div className="gl-con-wrap">
                                  <div className="line-graph-box">
                                    <span
                                      className="graph-current-bar"
                                      style={{
                                        width:
                                          String(
                                            (achieve &&
                                              (
                                                achieve[domainNames[3][1]] * 100
                                              ).toFixed(1)) + 0
                                          ) + "%",
                                      }}
                                    >
                                      <span className="current-txt">
                                        {achieve &&
                                          (
                                            achieve[domainNames[3][1]] * 100
                                          ).toFixed(1)}
                                        %
                                      </span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </li>
                            <li className="graph-list">
                              <span className="gl-title">
                                {domainNames[4][0]}
                              </span>
                              <div className="gl-con">
                                <div className="gl-con-wrap">
                                  <div className="line-graph-box">
                                    <span
                                      className="graph-current-bar"
                                      style={{
                                        width:
                                          String(
                                            (achieve &&
                                              (
                                                achieve[domainNames[4][1]] * 100
                                              ).toFixed(1)) + 0
                                          ) + "%",
                                      }}
                                    >
                                      <span className="current-txt">
                                        {achieve &&
                                          (
                                            achieve[domainNames[4][1]] * 100
                                          ).toFixed(1)}
                                        %
                                      </span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </section>
                  <section className="section section2">
                    <h2 className="ai-title">영역별 AI 추천 학습</h2>
                    <div className="ai-con">
                      <div className="ai-con-wrap">
                        <div className="uibox">
                          <div className="txt-box">
                            <span className="t-user">{name}</span> 학생의
                            전반적인 수학의 이해도 분석 및 예측이
                            완료되었습니다.{" "}
                            {t_type === "reg-mem"
                              ? parseInt(st_grade) <= 2
                                ? device_message[0]
                                : parseInt(st_grade) <= 4
                                ? device_message[1]
                                : parseInt(st_grade) <= 6
                                ? device_message[2]
                                : parseInt(st_grade) <= 7
                                ? device_message[3]
                                : device_message[4]
                              : parseInt(st_grade) <= 2
                              ? web_message[0]
                              : parseInt(st_grade) <= 4
                              ? web_message[1]
                              : parseInt(st_grade) <= 6
                              ? web_message[2]
                              : parseInt(st_grade) <= 7
                              ? web_message[3]
                              : web_message[4]}
                          </div>
                          <div className="table-box">
                            <div className="ai-data">
                              <span className="data data-improve">
                                보완 학습 필요
                              </span>
                              <span className="data data-fine">적정 수준</span>
                              <span className="data data-line">
                                적정 진도 기준선
                              </span>
                            </div>
                            <table className="ai-table table3">
                              <caption>분류표</caption>
                              <colgroup>
                                <col width="8%" />
                                <col />
                                <col />
                                <col />
                                <col />
                                <col />
                              </colgroup>
                              <thead>
                                <tr>
                                  <th>분류</th>
                                  <th>수와 연산</th>
                                  <th>{domainNames[1][0]}</th>
                                  <th>{domainNames[2][0]}</th>
                                  <th>{domainNames[3][0]}</th>
                                  <th>{domainNames[4][0]}</th>
                                </tr>
                              </thead>
                              <tbody>
                                {grade_range.map((grade) =>
                                  Object.keys(render_table[grade]).map(
                                    (seq_no, idx) => (
                                      <tr key={idx}>
                                        {render_table[grade][seq_no].map(
                                          (element) => element
                                        )}
                                      </tr>
                                    )
                                  )
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
                {!isPublic ? (
                  <div className="rm-button">
                    <button
                      className="button-bottom button-ai-go"
                      onClick={onClick}
                    >
                      {t_type === "reg-mem" ? "AI 추천 학습 보러가기" : "확인"}
                    </button>
                  </div>
                ) : (
                  <div className="rm-button">
                    <button
                      className="button-bottom button-ai-go"
                      onClick={ooResultPaperClick}
                    >
                      진단평가 시험 결과보기
                    </button>
                  </div>
                )}
              </div>
            </main>
            <ModalContainer popupState={popupState}></ModalContainer>
          </div>
        </div>
      </div>
    </>
  );
};
//
export default ResultForm;
